<ion-content [ngClass]="{ footer: isUsedInFooter }" no-border>
	<ion-segment
		scrollable
		mode="md"
		[value]="activeSelection"
		(ionChange)="segmentChanged($event)"
		class="ion-no-border"
	>
		<ion-segment-button [value]="table.tableName" *ngFor="let table of tables">
			<ion-label class="ion-no-margin" [ngClass]="{ 'red-title': shouldHighlight(table) }">
				{{ table.title }}
			</ion-label>
		</ion-segment-button>
	</ion-segment>
</ion-content>
